import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';
import { constructURL } from '../common';

const createCustomer = ({ data, headers = {} }) => {
    const url = API.USER;
    return fetchData({ body: { role_type: 'user', ...data }, method: METHODS.POST, url, headers });
};

const customerLogin = ({ data }) => {
    const url = API.CUSTOMER_LOGIN;
    return fetchData({ body: data, method: METHODS.POST, url });
};

const getAllCustomer = async ({
    offset,
    limit,
    search,
    id = '',
    role = '',
    hasPrimaryUser = undefined,
    withPlatforms = undefined,
    withPrimaryUsers = undefined,
    filter,
    orderBy,
}) => {
    const queryParams = {
        offset: offset ? offset : '',
        limit: limit ? limit : '',
        search: search ? encodeURIComponent(search) : '',
        id: id,
        role: role,
        hasPrimaryUser,
        withPlatforms,
        filter: filter ? encodeURIComponent(JSON.stringify(filter)) : undefined,
        withPrimaryUsers,
        orderBy : orderBy ? encodeURIComponent(JSON.stringify(orderBy)) : undefined
    };
    const url = constructURL(API.CUSTOMER_ENDPOINT, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

const getHiringClients = async ({
    account_id,
    platform_id,
    offset,
    limit,
    search,
    hiring_client_id,
    excludesScorecardHCs,
}) => {
    const queryParams = {
        account_id: account_id ? account_id : undefined,
        platform_id: platform_id ? platform_id : undefined,
        hiring_client_id: hiring_client_id ? hiring_client_id : undefined,
        search: search ? encodeURIComponent(search) : undefined,
        offset: offset ? offset : undefined,
        limit: limit ? limit : undefined,
        excludesScorecardHCs: excludesScorecardHCs ? excludesScorecardHCs : undefined,
    };
    const url = constructURL(API.HIRING_CLIENTS, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

const getCustomerByID = async ({ customerID, fetchPlatform, fetchHiringClient, fetchCSM }) => {
    const queryParams = {
        platform: fetchPlatform ? fetchPlatform : undefined,
        hiringClient: fetchHiringClient ? fetchHiringClient : undefined,
        csm: fetchCSM ? fetchCSM : undefined,
    };
    const url = constructURL(`${API.CUSTOMER_ENDPOINT}/${customerID}`, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

const getScoreCardDetails = ({ accountId, platformID, offset, limit, search }) => {
    let url = `${API.SCORECARD}?account_id=${accountId}&offset=${offset}&limit=${limit}`;
    if (platformID) url = `${url}&platform_id=${platformID}`;
    if (search) url = `${url}&search=${encodeURIComponent(search)}`;
    return fetchData({ method: METHODS.GET, url });
};

const createCustomerFeedback = ({ data }) => {
    const url = API.CUSTOMER_FEEDBACK;
    return fetchData({ body: data, method: METHODS.POST, url });
};
const getAllPrimaryUser = ({ offset, limit, search }) => {
    const queryParams = {
        offset: offset ? offset : '',
        limit: limit ? limit : '',
        search: search ? encodeURIComponent(search) : '',
    };
    const url = constructURL(API.USER, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

const getAllUser = ({ offset, limit, search }) => {
    const queryParams = {
        offset: offset ? offset : '',
        limit: limit ? limit : '',
        search: search ? encodeURIComponent(search) : '',
        filter: encodeURIComponent(JSON.stringify({ role: 'user' })),
    };
    const url = constructURL(API.USER, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

const getUserById = ({ id }) => {
    const url = `${API.USER}/${id}`;
    return fetchData({ method: METHODS.GET, url });
};

const createAccountUser = async (body) => {
    const url = `${API.ACCOUNT_USER}`;
    return fetchData({ body: body, method: METHODS.POST, url });
};

const deleteAccountUser = ({ data }) => {
    const url = `${API.ACCOUNT_USER}`;
    return fetchData({ body: data, method: METHODS.DELETE, url });
};

const patchAccountUserIsPrimaryAPI = ({
    account_id = undefined,
    user_id = undefined,
    is_primary = undefined,
}) => {
    const queryParams = { account_id, user_id, is_primary };
    const url = constructURL(`${API.ACCOUNT_USER}${API.USER}`, queryParams);
    return fetchData({ body: undefined, method: METHODS.PATCH, url });
};

export const updateUsersStatusAPI = ({ ids, status, sendEmail = undefined }) => {
    if (!Array.isArray(ids) || ids.length === 0) {
        throw new Error('ids should be an array of user ids');
    }
    let url = `${API.USER}`;
    return fetchData({ method: METHODS.PUT, url, body: { status, ids, sendEmail } });
};

const updateUser = ({ accountId, data }) => {
    const url = `${API.ACCOUNT_USER}/${accountId}`;
    return fetchData({ body: data, method: METHODS.PUT, url });
};

const getAccountByID = async ({
    id,
    withPTAndHC,
    withHC,
    withSC,
    withPT,
    withUsers,
    onlyPrimaryUsers,
    withDocumentRequests,
    hcLimit,
    hcOrderBy,
    documentLimit,
}) => {
    const url = constructURL(`${API.ACCOUNT}/${id}`, {
        withPTAndHC: withPTAndHC ?? undefined,
        withHC: withHC ?? undefined,
        withSC: withSC ?? undefined,
        withPT: withPT ?? undefined,
        withUsers: withUsers ?? undefined,
        onlyPrimaryUsers: onlyPrimaryUsers ?? undefined,
        withDocumentRequests: withDocumentRequests ?? undefined,
        hcLimit: hcLimit ?? undefined,
        hcOrderBy: hcOrderBy ?? undefined,
        documentLimit: documentLimit ?? undefined,
    });
    return fetchData({ method: METHODS.GET, url });
};

const updatePrimaryUser = ({ id, data }) => {
    const url = `${API.USER}/${id}`;
    return fetchData({ body: data, method: METHODS.PUT, url });
};

const initiateResetPassword = ({ body, headers }) => {
    const url = `${API.USER}${API.RESET_INITIATE}`;
    return fetchData({ body, method: METHODS.POST, url, headers });
};

const validateResetLink = ({ body, headers }) => {
    const url = `${API.USER}${API.VALIDATE_RESET_LINK}`;
    return fetchData({ body, method: METHODS.POST, url, headers });
};

const resetPassword = ({ body, headers }) => {
    const url = `${API.USER}${API.RESET_PASSWORD}`;
    return fetchData({ body, method: METHODS.POST, url, headers });
};

export const sendReport = async ({ id }) => {
    const url = `${API.REPORT}/${id}`;
    return fetchData({ method: METHODS.GET, url });
};

export const getCustomerDetailByIdAPI = async ({ id }) => {
    const url = API.CUSTOMER_DETAIL + `/${id}`;
    return fetchData({ method: METHODS.GET, url });
};

export const mergeCustomerAPI = async ({ schedular_id, admin_id }) => {
    const url = API.CUSTOMER_MERGE;
    return fetchData({ body: { schedular_id, admin_id }, method: METHODS.POST, url });
};

export {
    createCustomer,
    customerLogin,
    getAllCustomer,
    getUserById,
    getHiringClients,
    getCustomerByID,
    getScoreCardDetails,
    createCustomerFeedback,
    getAllPrimaryUser,
    updateUser,
    getAccountByID,
    updatePrimaryUser,
    initiateResetPassword,
    validateResetLink,
    resetPassword,
    createAccountUser,
    deleteAccountUser,
    getAllUser,
    patchAccountUserIsPrimaryAPI,
};
